import { startLoading } from "./loadingBar";

// The account and office lists are what people open these pages for, and on a
// slow connection every Firestore read waits in line on the same connection.
// So the reads nobody is looking at yet (sidebar badges, the bell, the lists
// behind the filter menus, the background download of the other screens)
// start only once the list on the page has shown its rows.
//
// A list calls holdForList() while it renders for the first time and calls
// the function it gets back when its rows are on screen (or when it goes
// away). Everything else uses whenListShown(start), which runs `start` right
// away when no list is loading, else once the list is shown, and in any case
// after MAX_WAIT_MS, so nothing waits forever.
const MAX_WAIT_MS = 3000;
// While a list is held, the portal's loading bar runs (utility/loadingBar).

let holds = 0;
let waiting = [];

const runWaiting = () => {
  const run = waiting;
  waiting = [];
  run.forEach((entry) => entry.fire());
};

export const holdForList = () => {
  holds += 1;
  let released = false;
  const stopBar = startLoading();
  const release = () => {
    if (released) return;
    released = true;
    stopBar();
    holds -= 1;
    if (holds <= 0) {
      holds = 0;
      runWaiting();
    }
  };
  // Never hold the rest of the page for longer than this.
  setTimeout(release, MAX_WAIT_MS);
  return release;
};

// Runs start() now or once the list is shown. Returns a cancel function; if
// start() returned a cleanup function (an unsubscribe), cancel calls it.
export const whenListShown = (start) => {
  let cleanup = null;
  let cancelled = false;
  const entry = {
    fire: () => {
      if (cancelled) return;
      const result = start();
      if (typeof result === "function") cleanup = result;
    },
  };
  if (holds <= 0) {
    entry.fire();
  } else {
    waiting.push(entry);
    setTimeout(() => {
      if (waiting.includes(entry)) {
        waiting = waiting.filter((other) => other !== entry);
        entry.fire();
      }
    }, MAX_WAIT_MS);
  }
  return () => {
    cancelled = true;
    waiting = waiting.filter((other) => other !== entry);
    if (cleanup) cleanup();
  };
};
